const TITLES = {
  MODULE: 'Module',
  MODULE_DETAILS: 'Module Details',
  MODULE_NAME: 'Module Display Name',
  MODULE_ID: 'Module ID',
  MODULE_KEY: 'Module Key',
  SERVICE_ID: 'Service ID',
  MODULE_DESCRIPTION: 'Description',
  APPLICATION_ID: 'Application ID',
  ORGANIZATION_ID: 'Organization ID',
  COPIED_TO_CLIPBOARD: "{0} copied to clipboard",
};

export { TITLES };